import * as UI from '@brewlogix/blx-ui'

import { DateTime } from 'luxon'
import React from 'react'
import { Location, LocationStatus } from 'src/types/schema/graphql'
import { daysOfWeek } from 'src/util/constants'
import { parseEnumLabel } from 'src/util/helpers'
import { getOpenStatus } from '../../utils/helpers'

interface ICurrentDayStatus {
    location: Location
}

const CurrentDayStatus: React.FC<ICurrentDayStatus> = ({ location }) => {
    const businessStatus =
        location?.traits?.status === LocationStatus.Closed
            ? 'Permanently Closed'
            : location?.traits?.status
    const openForBusiness = businessStatus === LocationStatus.OpenForBusiness
    let openNowStatus: string = businessStatus
    let textColor: string = businessStatus === 'Permanently Closed' ? 'text-error' : 'text-dark'

    if (openForBusiness) {
        const nowIndex = DateTime.now().weekday
        const today = location.hours.find(
            ({ day }) => day === daysOfWeek[nowIndex === 7 ? 0 : nowIndex].label
        )
        const openStatus = getOpenStatus(today)
        openNowStatus = parseEnumLabel(openStatus?.message)
        textColor = openStatus?.isOpenNow ? 'text-primary' : 'text-error'
    }
    return (
        <div className='flex w-full items-center gap-x-1'>
            <UI.Icon size='sm' customClasses='mr-1' slug='HeroIcons.Clock' />
            <strong className={textColor}>{openNowStatus}</strong>
        </div>
    )
}

export default React.memo(CurrentDayStatus)
